import { render, staticRenderFns } from "./PostingDetailSupport.vue?vue&type=template&id=7a396300&scoped=true&"
import script from "./PostingDetailSupport.vue?vue&type=script&lang=js&"
export * from "./PostingDetailSupport.vue?vue&type=script&lang=js&"
import style0 from "./PostingDetailSupport.vue?vue&type=style&index=0&id=7a396300&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a396300",
  null
  
)

export default component.exports